module.exports = __webpack_public_path__ + "static/img/1_8_2.72057c83.jpg";